@if (isVisible) {
  <div class="file-upload" [formGroup]="formGroup">
    <form-control-label [id]="controlId" [question]="componentData" [flow]="flowComponent"></form-control-label>
    @if (useRadioButtons) {
      <div class="margin-bottom">
        @for (option of selectedOptions; track option) {
          <div class="padding-bottom-small">
            <label>
              <input type="radio"
                [value]="option"
                [name]="componentData.key"
                [disabled]="disableScanView"
                [checked]="selectedOption === option"
                (click)="optionChanged(option)" /> {{ option.displayText }}
              </label>
            </div>
          }
        </div>
      }
      @if (isEdit || showUpload) {
        @if (disable) {
          <div class="drop-area grid-x screen-only">
            <span>
              <i>File upload is disabled.</i>
            </span>
          </div>
        }
        @if (!disable) {
          <div #fileUploadLabel [ngClass]="{'drop-active': hasFilesToDrop }" (dragover)="onDragOver($event)" (drop)="onDrop($event)" (dragleave)="onDragLeave($event)" class="drop-area grid-x screen-only">
            <div class="padding-all text-align-center">
              <span class="upload-text-container">
                <svg-icon title="File Upload" icon="icon-upload" class="small dark-gray minor-margin-right" aria-hidden="true"></svg-icon>
                <span aria-hidden="true">Drag files here or </span>
                <label [for]="'file' + controlId" class="file-select-label"><span role="button" class="outline-offset-1" aria-controls="'file' + controlId" tabindex="0" (keyup.enter)="chooseFileLabelClick($event)">Choose File</span></label>
              </span>
              <button class="button upload-button no-margin outline-offset-1" (click)="chooseFileLabelClick($event)"><svg-icon title="File Upload" icon="icon-upload" class="small white minor-margin-right" aria-hidden="true"></svg-icon>Upload File</button>
              <input #input type="file" [id]="'file' + controlId" name="file" multiple class="file-select" (change)="addFiles($event)">
            </div>
          </div>
        }
        @if (hasFileListing) {
          <div class="file-list padding-all-small">
            <h3 class="minor-margin-bottom h6">Uploaded Files:</h3>
            @for (file of files; track file) {
              <file-upload-item [file]="file" [allowDeletion]="allowFileDeletion(file)"></file-upload-item>
            }
          </div>
        }
      }
      @if (isEdit || showText) {
        <span [innerHTML]="deliverText | safeHtml"></span>
      }
    </div>
    <a style="display:none" #fileDownload></a>
  }

